import "./index.css";
import "./languages/i18n";

import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import { App } from "./App";
import { getEnviroment } from "./utils/environment";

const APP_ENV = getEnviroment();
export const queryClient = new QueryClient();

if (APP_ENV !== "local") {
  Sentry.init({
    dsn: "https://560b83cd8bafe067439e7f0d0b450c62@o4508444992733184.ingest.us.sentry.io/4509707251351552",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: `${APP_ENV}`,
    // TO-DO: add tracing propagation target
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
